/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, IWrapHTTPConfig } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ResponseFileDto } from '../models/response-file-dto';
import { ResponseFileItemDto } from '../models/response-file-item-dto';

@Injectable({
  providedIn: 'root',
})
export class CommonFilesApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation upload
   */
  static readonly UploadPath = '/api/v1/common/files/upload';

  /**
   * Upload new file
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  private upload$Response(params: {
    module: 'UPDATE' | 'CHAT' | 'JOURNAL' | 'PROFILE';
    entityName?: string;
    previewCompressionMode?: 'TO_SIZE_500' | 'TO_SIZE_700' | 'TO_SIZE_900' | 'WITHOUT_COMPRESSION';
    body?: {
'file': Blob;
}
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseFileItemDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommonFilesApiService.UploadPath, 'post');
    if (params) {
      rb.query('module', params.module, {});
      rb.query('entityName', params.entityName, {});
      rb.query('previewCompressionMode', params.previewCompressionMode, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseFileItemDto>;
      })
    );
  }

  /**
   * Upload new file
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `upload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  upload(params: {
    module: 'UPDATE' | 'CHAT' | 'JOURNAL' | 'PROFILE';
    entityName?: string;
    previewCompressionMode?: 'TO_SIZE_500' | 'TO_SIZE_700' | 'TO_SIZE_900' | 'WITHOUT_COMPRESSION';
    body?: {
'file': Blob;
}
  }, config?: IWrapHTTPConfig
): Observable<ResponseFileItemDto> {

    return this.wrapHTTPQuery(this.upload$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseFileItemDto>) => r.body as ResponseFileItemDto)
    ), config);
  }

  /**
   * Path part for operation getFile
   */
  static readonly GetFilePath = '/api/v1/common/files/uuid/{uuid}';

  /**
   * get file data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  private getFile$Response(params: {
    uuid: string;
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseFileDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommonFilesApiService.GetFilePath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseFileDto>;
      })
    );
  }

  /**
   * get file data
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFile(params: {
    uuid: string;
  }, config?: IWrapHTTPConfig
): Observable<ResponseFileDto> {

    return this.wrapHTTPQuery(this.getFile$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseFileDto>) => r.body as ResponseFileDto)
    ), config);
  }

}
